export default {
    install: (Vue) => {
        Vue.mixin({
            methods: {
                formatFilteredAPIMixin({
                    filters, 
                    setPagination = 1, 
                }){

                    const { 
                        withECPF, 
                        totalValue, 
                    } = filters

                    return {
                        withECPF,
                        minOrderValue: totalValue.minValue,
                        maxOrderValue: totalValue.maxValue,
                        page: setPagination,
                    }
                },
            },
        })
    }
}